import dayjs from "dayjs";
import type { Dayjs } from "dayjs"; // 타입만 가져오기
import utcPlugin from "dayjs/plugin/utc";
import timezonePlugin from "dayjs/plugin/timezone";
//import "dayjs/locale/en";
// import "dayjs/locale/de";
// import "dayjs/locale/ko";
// import "dayjs/locale/ja";
// import "dayjs/locale/zh-cn";
// import "dayjs/locale/zh-tw";
// import "dayjs/locale/zh-hk";
// import "dayjs/locale/es";
// import "dayjs/locale/fr";
// import "dayjs/locale/pt";
// import "dayjs/locale/ru";
// import "dayjs/locale/ar";
// import "dayjs/locale/hi";
// import "dayjs/locale/vi";
// import "dayjs/locale/th";
// import "dayjs/locale/id";

dayjs.extend(utcPlugin);
dayjs.extend(timezonePlugin);

const localeMap: Record<string, string> = {
  "ko-KR": "ko",
  "ja-JP": "ja",
  "zh-cn": "zh-cn",
  "zh-tw": "zh-tw",
  "zh-hk": "zh-hk",
  "en-US": "en",
  "en-GB": "en",
  "de-DE": "de",
  "es-ES": "es",
  "fr-FR": "fr",
  "pt-PT": "pt",
  "ru-RU": "ru",
  "ar-SA": "ar",
  "hi-IN": "hi",
  "vi-VN": "vi",
  "th-TH": "th",
  "id-ID": "id",
};

export const setDayjsLocale = (locale: string) => {
  if (locale) {
    const normalizedLocale = localeMap[locale] || locale;
    dayjs.locale(normalizedLocale);
  }
};

export default dayjs;
export type { Dayjs }; // Dayjs 타입 내보내기
